module.exports = __webpack_public_path__ + "assets/128233b2f44d602af4d5846af58d7fa3.mp3";